import React, { Component } from 'react';
import styled from 'styled-components';
import { Flex, Box } from 'grid-styled';
import { FullWidthContainer } from "../styles/FullWidthContainer";
import { color } from "../styles/helpers/variables";

class MobileNav extends Component {
  render() {
    return (
      <FullWidthContainer>
        <FullWidthFlex>
          <MyBox onClick={() => this.props.toggleModal('filter')} width={'37%'}>
            FILTRERA
          </MyBox>
          <MyBox onClick={() => this.props.toggleModal('page')} width={'26%'}>
            {this.props.currentPage} / {this.props.pages}
          </MyBox>
          <MyBox onClick={() => this.props.toggleModal('sort')} width={'37%'}>
            SORTERA
          </MyBox>
        </FullWidthFlex>
      </FullWidthContainer>
    );
  }
}

const FullWidthFlex = styled(Flex)`
  width: 100%;
`;

const MyBox = styled(Box)`
  padding: 1rem .5rem;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2px;
  text-align: center;
  color: ${color.black};
  cursor: pointer;
  
  &:first-of-type,
  &:last-of-type {
    border-top: solid 1px #c5c5c5;
    border-bottom: solid 1px #c5c5c5;
  }
  
  &:nth-child(2) {
    border: solid 1px #c5c5c5;
  }
`;

export default MobileNav;



// WEBPACK FOOTER //
// ./src/components/MobileNav.js